import React, { ReactNode, useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { CustomThemeContext } from '../../themes/ThemeContext';

const PageHeader = ({
	title,
	children,
	hFontSize,
	hideLine
}: {
	title: string;
	children?: ReactNode;
	hFontSize?: string;
	hideLine?: boolean;
}) => {
	const { isDark } = useContext(CustomThemeContext);

	return (
		<Box display="flex" flexDirection="column" gap={3} width="100%">
			<Box
				sx={{
					display: 'flex',
					justifyContent: { xs: 'center', md: 'space-between' },
					alignItems: 'center',
					borderBottom: {
						xs: 'none',
						md: hideLine ? 'none' : isDark ? '1px solid rgba(255,255,255,0.6)' : '#666565 solid 1px'
					},
					flexDirection: { xs: 'column', sm: 'row' },
					pb: 2
				}}
			>
				<Typography
					variant="h1"
					sx={{
						fontWeight: 'bold',
						fontSize: { xs: '22px', md: hFontSize ?? '36px' },
						textAlign: { xs: 'center', sm: 'left' },
						pb: { xs: 1, sm: 0 }
					}}
				>
					{title}
				</Typography>
				{children}
			</Box>
		</Box>
	);
};

export default PageHeader;
